import { responsiveFontSizes } from '@material-ui/core/styles';
import { orange, grey, blue } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

let darkTheme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: ['Visuelt', 'Roboto', 'Helvectica Neue', 'Helvetica', 'Arial', 'sans-serif']
  },
  palette: {
    primary: {
      main: '#00000',
      themeColor: '#01B5DE',
      dark: '#335977',
      yellow: '#FFE785',
      faded: '#C9C9C9',
      lightBlack: '#5C5C5C',
      dataBlack: '#999999',
      white: '#FFFFFF',
      mainText: '#f8f8ff',
      mainText2: '#ffff',
      disableBg: '#F6F6F6',
      subText: '#d8dcde',
      header: '#333333',
      smartEvCard: '#373737',
      headerTitle: '#FFFFFF',
      cards: '#262627',
      cardsBox: '0 2px 10px 0 rgba(0, 0, 0, 0.25)',
      heading: '#fff',
      border: '1px solid rgba(123, 135, 147, 0.2)',
      borderColor: 'rgba(123, 135, 147, 0.3)',
      disabledText: '#d8dcde',
      underline: '#d8dcde',
      background: '#262627',
      popupBackground: '#262627',
      text: '#ffffff',
      progress: '1px solid #7b8793',
      hint: '#7b8793',
      highlight: '#fff',
      subHeading: '#ffffff',
      title: '#ffff',
      hover: '#262627',
      label: '#000',
      msgText:"#A2A6A9",
      arrowIcon: "#f8f8ff",
      subHeader: "#FFF",
      toastBackground: "#545456",
      cardBackground: "#333333",
      mainHeading: "#FFFFFF",
      errorToastBackground: "#ff5959",
      popupDivider: "#FFFFFF",
      cardText: "#FFFFFF",
      emptyStateTextColor: "#FFFFFF",
      dashedBorderColor: "#6B7073",
      inputLabelColor: "#A9A9AA",
      iqAirSettingsCardColor: "#262627",
      iqAirSettingsCardIconBorder: "#6B7073",
      iqAirSettingsCardIconBg: "#333",
      dropdownBorder:'#A9A9AA',
      ...orange
    },
    secondary: {
      main: '#01B4DE',
      link: '#47B5DE',
      text: '#A4A5A8',
      background: '#262627',
      subHeader: '#01b5de',
      arrowIcon: '#01b5de',
      subHeading: "#A9A9AA",
      ...blue
    },
    tertiary: {
      main: '#FFFFFF',
      light: '#FAFAFA',
      dark: '#7E7E7E',
      background: '#7E7E7E',
      card: "#333",
      cardText:"#CBCED1",
      boxText : "#CBCED1",
      container:"#333",
      sheetContainer:"#333333",
      tabBorder:"#333333",
      tabBackground:"#2E2E30",
      inputBox:"#2E2E30",
      titleBox: "#FFFFFF",
      NoEvDataMessage : '#CBCED1',
      drawerContent: "#8e9091",
      buttonColor:"#333333",
      labelText:"#FFFFFF",
      inputText:"#FFFFFF",
      headingText:"#FFFFFF",
      headingText2:"#FFFFFF",
      popUpHeading:"#FFFFFF",
      popUpContent:"#CBCED1",
      popupHeadingBorder:"#CBCED180",
      popupActionButtonBorder: "#CBCED180",
      dividerBorderColor: '#CBCED180',
      muiDivider: '#CBCED180',
      popupTitleText:"#FFFFFF",
      closeIconColor: '#D9DCDE',
      inputBorderBottom: '#C6C8CA',
      timeCardBtn: '#FFFFFF',
      applyDisabledColor : '#A9A9AA',
      lightColor: '#A9A9AA',
      liveStatusTitle : '#FFFFFF',
      chargerTitle: '#CBCED1',
      chargerInfo: '#A2A6A9',
      chargerImageBackgroundColor: '#252527',
      provisiningSubHeading: '#A9A9AA',
      updatePopUpTitle: '#D9DCDE',
      timePickBackgroundColor: '#252527',  
      timePickBackgroundColorForChargingModes: "#333333",
      clockIconColor: '#FFFFFF',
      ChargeIconOuterFill: '#262627',
      ChargeIconFill: '#FFFFFF',
      ChargeIconFillInner: '#FFFFFF80',
      ChargeIconStroke: '#3d4044',
      drawerBackgroundColor: '#252527',
      evDetailsBackgroundColor : '#262627',
      evDetailsDataColor: "#CBCED1",
      blackText : '#FFFFFF',
      dividerBackgroundColor: '#5f6061',
      errorMessageColor : "#f44336",
      toggleButtonColor : "#D0D0D0",
      radioButtonColor : '#CBCFD2',
      loaderTile: '#262627',
      radioButtonCheckedColor : '#01B4DE',
      radioButtonDisabledColor: '#6B7073',
      schedulesCustomTimes : '#A2A6A9',
      provisionDisableButton : '#7ed7ec', 
      provisionEnableButton : '#01b5de', 
      provisionBordercolor: '#01B5DE', 
      provisionRestartBtn : '#FFFFFF',
      lighter: grey[100],
      permissionDesc:'#333333',
      permissionTextLight: '#A9A9AA',
      disableButton: '#505051',
      quickTipsInfoMsg: '#A2A6A9',
      swiperBullets: '#6C7073',
      swiperActiveBullet: '#FFFFFF',
      disableApplyButtonBg: '#6B7073',
      disableApplyButtonText: '#A9A9AA',
      inputLabel: '#6B7073',
      noteBox:'#444',
      wireConfigKnowMore: "#01B5DE",
      drawerBackgroundV2: "#262627",
      sliderValue:"#01B5DE",
      checkBoxConfirmationBackground: "#333333",
      checkBoxBorder: "#BABEC3",
      commonText:"#A9A9AA",
      infoIcon:'#6B7073',
      checkBoxFill: "#01B5DE",
      learnMoreBgv: "#223439",
      buttonV2: "#01B5DE",
      disabledLinkButton: '#a2abb3',
      subtextV2: "#A2A6A9",
      sliderCardBackground: "#333333",
      commonButtonBackground : "#01B5DE",
      greyedOutText: "#A9A9AA",
      connectionMediumContainer: "#333333",
      noticeBorder: '#BABEC3',
      subHeader: "#01B5DE",
      ...grey
    },
    icon: {
      default: '#d8dcde',
      svgIcon:"#252527",
      wifiIcon:"#999"
    
    }
  },
  overrides: {
    MuiStepIcon: {
      text: {
        fontSize: '13px',
        '&$active': {
          // color: '#F3731F'
        },

        fontWeight: 'bold',
        fill: '#FFFFFF'
      },
      root: {
        '&$active': {
          // color: '#F3731F'
        }
      }
    }
  }
});

darkTheme = responsiveFontSizes(darkTheme);

export default darkTheme;
